import { createTheme, ThemeProvider } from "@material-ui/core/styles";
// import { theme } from "../style/theme";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { createTheme as createThemeV5, ThemeProvider as Mui5ThemeProvider } from "@mui/material/styles";
import React from "react";

export function DynamicColorPreset({ children, client }) {
    const styledTheme = {
        primary: client.brand_color1,
        secondary: client.brand_color2,
        tertiary: client.brand_color3,
        header: client.brand_color_header,
        headericons: client.brand_color_header_icons,
        text: client.brand_color3,
        gray: '#e8e8e8',
        black: '#000',
        white: '#fff',
    };

    const themeCustomized = createTheme({
        typography: {
            fontFamily: 'Titillium Web, Raleway, sans-serif',
        },
        // ...theme,
        palette: {
            primary: {
                main: styledTheme.primary,
            },
            secondary: {
                main: styledTheme.secondary,
            },
            tertiary: {
                main: styledTheme.tertiary,
            },
            white: {
                main: styledTheme.white,
            },
            header: {
                main: styledTheme.header,
            },
            headericons: {
                main: styledTheme.headericons,
            },
        },
        overrides: {
            MuiOutlinedInput: {
                root: {
                    borderRadius: '10px !important',
                },
            },
            MuiFormControl: {
                root: {
                    width: '100%',
                },
            },
            MuiButton: {
                root: {
                    borderRadius: 4,
                    //textTransform: 'none',
                    //fontWeight: 'bold',
                    padding: '14px 22px !important',
                },
                sizeLarge: {
                    padding: '14px 22px !important',
                },
                sizeSmall: {
                    padding: '8px 12px !important',
                },
                text: {
                    borderRadius: 0,
                },
                label: {
                    // color: styledTheme.white,
                },
                containedSizeSmall: {
                    padding: '5px 10px !important',
                }
            },
        },
    });
    const themeCustomizedV5 = createThemeV5({
        typography: {
            fontFamily: 'Titillium Web, Raleway, sans-serif',
        },
        // ...theme,
        palette: {
            primary: {
                main: styledTheme.primary,
            },
            secondary: {
                main: styledTheme.secondary,
            },
            tertiary: {
                main: styledTheme.tertiary,
            },
            white: {
                main: styledTheme.white,
            },
            headericons: {
                main: styledTheme.headericons,
            },
        },
        components: {
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        width: '100%',
                    },
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 4,
                        //textTransform: 'none',
                        //fontWeight: 'bold',
                        padding: '14px 22px !important',
                    },
                    sizeLarge: {
                        padding: '14px 22px !important',
                    },
                    sizeSmall: {
                        padding: '8px 12px !important',
                    },
                    text: {
                        borderRadius: 0,
                    },
                    label: {
                        // color: styledTheme.white,
                    },
                    containedSizeSmall: {
                        padding: '5px 10px !important',
                    },
                },
            },
            MuiStepIcon: {
                styleOverrides: {
                    root: {
                        color: 'white',
                        "&.Mui-active": {
                            color: '#2A5B97',
                            text: {
                                fill: '#fff',
                            },
                        },
                    },
                    text: {
                        fill: '#828282',
                    },
                },
            },
            MuiStepLabel: {
                styleOverrides: {
                    root: {
                        color: '#828282',
                    },
                },
            },
        },
    });

    return (
        <Mui5ThemeProvider theme={themeCustomizedV5}>
            <StyledThemeProvider theme={styledTheme}>
                <ThemeProvider theme={themeCustomized}>
                    {children}
                </ThemeProvider>
            </StyledThemeProvider>
        </Mui5ThemeProvider>
    );
}
